/** Shared joyful styling for Pobble Home (parent) pages */
export const PARENT_PAGE_BG =
  'linear-gradient(180deg, #faf5ff 0%, #fffbea 45%, #eef8fc 100%)'

export const PARENT_PRIMARY_CTA = {
  background: 'var(--purple)',
  color: '#fff',
  fontWeight: 600,
  borderColor: 'rgba(0,0,0,0.1)',
  textAlign: 'center !important',
  fontSize: '16px',
  justifyContent: 'center !important',
  '&:hover': {
    background: 'var(--purple-)',
    color: '#fff'
  },
  '&:disabled': {
    background: '#dedede !important',
    borderColor: '#dedede !important',
    color: '#999 !important',
    cursor: 'not-allowed',
    pointerEvents: 'none',
    '&:hover': {
      background: '#dedede !important',
      color: '#999 !important'
    }
  }
}

export const PARENT_PAGE_HEADER = {
  textAlign: 'center',
  marginBottom: '36px',
  '@media (min-width: 1024px)': {
    marginBottom: '48px'
  },
  '& h2': {
    margin: '0 0 12px',
    font: 'var(--heading)',
    color: 'var(--gray)',
    fontSize: '32px'
  },
  '& p': {
    margin: '0 auto',
    maxWidth: '760px',
    color: 'var(--gray--)',
    font: 'var(--body)',
    lineHeight: 1.55,
    fontSize: '18px'
  }
}

export const PARENT_CARD = {
  background: '#fff',
  borderRadius: '16px',
  overflow: 'hidden',
  border: '1px solid var(--purple--)',
  boxShadow: '0 8px 24px rgba(129, 95, 165, 0.12)',
  display: 'flex',
  flexDirection: 'column'
}

export const PARENT_FILTER_ACTIVE = {
  background: 'var(--purple) !important',
  color: '#fff !important',
  borderColor: 'var(--purple) !important',
  '&:hover': {
    background: 'var(--purple-) !important',
    color: '#fff !important'
  }
}

/** Hero overlays — soft purple instead of near-black */
export const PARENT_HERO_GRADIENT_TOP =
  'linear-gradient(to bottom, rgba(129, 95, 165, 0.75), rgba(129, 95, 165, 0.35), rgba(129, 95, 165, 0))'

export const PARENT_HERO_GRADIENT_BOTTOM =
  'linear-gradient(to top, rgba(129, 95, 165, 0.88), rgba(129, 95, 165, 0.4), rgba(129, 95, 165, 0))'

export const PARENT_STICKY_HEADER_BG = '#faf8fc'
